import React from 'react';
import List, {defaultFilters} from '../cruds/List';
import Edit from '../cruds/Edit';
import {notNullValidatorCancMutag} from '../cruds/validators';
import {
    ActionButtons,
    ArchiveEvaluationButton,
    NewEvaluationButton,
    PrintEvaluationButton,
    ViewEvaluationButton
} from './SubstancesManagementButtons';
import OutputBox, {
    OutputBoxContent,
    Show_If_Mutagen_Cancerous,
    Show_IfNOT_Mutagen_Cancerous,
} from '../components/output/OutputBox';
import {
    EVALUATION_DESCRIPTION_VISIBLE,
    ShowBasedOnConfig,
    SUBSTANCE_INVENTORY_VISIBLE
} from '../components/container/ShowBasedOnConfig';
import OutputValue, {LocalizedOutputValue} from '../components/output/OutputValue';
import {SimpleOutputText} from '../components/output/OutputText';
import DropdownDownloadButton, {DropdownDownloadContent} from '../components/output/DropdownDownloadButton';
import RemoteInputSelect from '../components/input/RemoteInputSelect';
import {dateTimeFormatter, decimalFormatter} from '../functions/textFormatter';
import InputText from '../components/input/InputText';
import InputCheckbox from '../components/input/InputCheckbox';
import InputTextAutocomplete from '../components/input/InputTextAutocomplete';
import InputNumber from '../components/input/InputNumber';
import {BoxEdit} from '../components/container/Box';
import CollapsibleRowList from '../components/container/CollapsibleRow';
import MainContainer from '../components/MainContainer';
import {Horizontal, HorizontalInput, Vertical} from '../components/container/LayoutRow';
import {Route, Switch} from 'react-router-dom';
import Evaluations from './Evaluations';
import {fetchPost} from '../cruds/remote';
import AdvancedSearch from './AdvancedSearch';
import WithRole from '../components/container/WithRole';
import PropTypes from 'prop-types';
import getLabel from '../translations/messages';
import './SubstancesManagement.css';

const ENTITY_NAME = 'departmentActivitySubstances';
const ENTITY_ROUTE = 'substances/management';
const TITLE = 'substancesManagement.title';

const evaluate = (resource) => {
    return fetchPost(ENTITY_NAME + '/reevaluation-needed', resource);
};

const LastEvaluationText = ({style}, {locale}) => (
    <span style={style}>{getLabel(locale, 'evaluations.last') + ': '}</span>
);

LastEvaluationText.contextTypes = {
    locale: PropTypes.string,
};

const SubstanceOutputText = ({value, style}) => (
    <span style={style}>{value}</span>
);

const CrudEdit = props => {
    const validators = [
        notNullValidatorCancMutag('contactFrequency', 'substancesManagement.err.contactFrequency'),
        notNullValidatorCancMutag('exposureTime', 'substancesManagement.err.exposureTime'),
        //stringNotBlank('dpiUsage', 'evaluations.err.dpiUsage'),


        notNullValidatorCancMutag('revelationProcessTemperaturePre', 'evaluations.err.revelationProcessTemperature'),
        notNullValidatorCancMutag('revelationHandlingTimeMinutesPre', 'evaluations.err.revelationHandlingTimeMinutes'),
        notNullValidatorCancMutag('revelationFrequencyOfUseDaysPre', 'evaluations.err.revelationFrequencyOfUseDays'),

    ];
    return (
        <Edit {...props}
              title={TITLE}
              entityName={ENTITY_NAME}
              entityRoute={ENTITY_ROUTE}
              entityId={props.match.params.number}
              crudClassName="substancesManagement"
              validators={validators}
              preSubmit={(resource) => evaluate(resource)}
        >
            <SimpleOutputText name="departmentName" label="substancesManagement.department"/>
            <SimpleOutputText name="activityName" label="substancesManagement.activity"/>
            <SimpleOutputText name="substanceCode" label="substancesManagement.substance"/>

            <Show_If_Mutagen_Cancerous>
                <RemoteInputSelect
                    from={ENTITY_NAME + '/revelationProcessTemperaturePre'}
                    label="substancesManagement.revelationProcessTemperaturePre"
                    name="revelationProcessTemperaturePre"
                    optionValueName="value"
                    optionLabelName="label"
                    style={{flex: 3, flexBasis: 'auto'}}
                    localize="substancesManagement.revelationProcessTemperatureValuesPre"
                />
            </Show_If_Mutagen_Cancerous>

            <Show_If_Mutagen_Cancerous>
                <InputNumber
                    name="revelationHandlingTimeMinutesPre"
                    label="substancesManagement.revelationHandlingTimeMinutesPre"
                    style={{flex: '0.5 1 auto', marginRight: '10px'}}
                />
            </Show_If_Mutagen_Cancerous>
            <Show_If_Mutagen_Cancerous>
                <InputNumber
                    name="revelationFrequencyOfUseDaysPre"
                    label="substancesManagement.revelationFrequencyOfUseDaysPre"
                    style={{flex: '0.5 1 auto', marginRight: '10px'}}
                />
            </Show_If_Mutagen_Cancerous>


            <Show_IfNOT_Mutagen_Cancerous>
                <BoxEdit label="substancesManagement.dailyQuantity.comparator">
                    <HorizontalInput style={{alignItems: 'center'}}>
                        <SimpleOutputText value="Max" style={{flex: '0.5 1 auto', textAlign: 'center'}}/>
                        <InputText
                            name="maxDailyQuantity.value"
                            label="substancesManagement.quantity"
                            style={{flex: '0.5 1 auto', marginRight: '10px'}}
                        />
                        <InputTextAutocomplete
                            from={ENTITY_NAME + '/units'}
                            name="maxDailyQuantity.unit"
                            label="substancesManagement.unit"
                            style={{flex: '2 1 auto'}}
                        />
                    </HorizontalInput>
                    <HorizontalInput style={{alignItems: 'center'}}>
                        <SimpleOutputText value="Min" style={{flex: '0.5 1 auto', textAlign: 'center'}}/>
                        <InputText
                            name="minDailyQuantity.value"
                            label="substancesManagement.quantity"
                            style={{flex: '0.5 1 auto', marginRight: '10px'}}
                        />
                        <InputTextAutocomplete
                            from={ENTITY_NAME + '/units'}
                            name="minDailyQuantity.unit"
                            label="substancesManagement.unit"
                            style={{flex: '2 1 auto'}}
                        />
                    </HorizontalInput>
                </BoxEdit>
            </Show_IfNOT_Mutagen_Cancerous>


            <Show_IfNOT_Mutagen_Cancerous>
                <BoxEdit label="substancesManagement.presentQuantity.comparator" style={{margin: '10px 0'}}>
                    <HorizontalInput style={{alignItems: 'center'}}>
                        <SimpleOutputText value="Max" style={{flex: '0.5 1 auto', textAlign: 'center'}}/>
                        <InputText
                            name="maxActualQuantity.value"
                            label="substancesManagement.quantity"
                            style={{flex: '0.5 1 auto', marginRight: '10px'}}
                        />
                        <InputTextAutocomplete
                            from={ENTITY_NAME + '/units'}
                            name="maxActualQuantity.unit"
                            label="substancesManagement.unit"
                            style={{flex: '2 1 auto'}}
                        />
                    </HorizontalInput>
                </BoxEdit>
            </Show_IfNOT_Mutagen_Cancerous>

            <Show_IfNOT_Mutagen_Cancerous>
                <RemoteInputSelect
                    from={ENTITY_NAME + '/contactFrequencyValues'}
                    label="substancesManagement.frequency.name"
                    name="contactFrequency"
                    optionValueName="value"
                    optionLabelName="label"
                    style={{flex: 2}}
                    localize="substancesManagement.contactFrequencyValues"
                    required
                />
            </Show_IfNOT_Mutagen_Cancerous>

            <Show_IfNOT_Mutagen_Cancerous>
                <RemoteInputSelect
                    from={ENTITY_NAME + '/exposureTimeValues'}
                    label="substancesManagement.expositionTime.name"
                    name="exposureTime"
                    optionValueName="value"
                    optionLabelName="label"
                    style={{flex: 2}}
                    localize="substancesManagement.expositionTimeValues"
                    required
                />
            </Show_IfNOT_Mutagen_Cancerous>

            <ShowBasedOnConfig name="stock" configKey={SUBSTANCE_INVENTORY_VISIBLE}>
                <InputText
                    label="substancesManagement.stock.displayLabel"
                    style={{flex: '0.5 1 auto', marginRight: '10px'}}
                />
            </ShowBasedOnConfig>

            <ShowBasedOnConfig name="dailyUsage" configKey={SUBSTANCE_INVENTORY_VISIBLE}>
                <InputText
                    label="substancesManagement.dailyUsage.displayLabel"
                    style={{flex: '0.5 1 auto', marginRight: '10px'}}
                />
            </ShowBasedOnConfig>

            <InputTextAutocomplete from={ENTITY_NAME + '/dpiUsages'} name="dpiUsage" label="evaluations.dpiUsage"
                                   style={{marginTop: 20}} required/>


            <InputCheckbox name="usingDpc" label="evaluations.usingDpc"/>

        </Edit>
    );
};

const rowMarker = (resource) => (
    (resource.toBeEvaluated ? 'to-be-evaluated' : '') + ' '
    + (resource.enabled ? '' : 'das-disabled')
);

const exportButtons = (filters, context, toggleModal) => {
    return (
        <div>
            <DropdownDownloadButton tooltip="general.export" handleError={toggleModal}>
                <DropdownDownloadContent from={ENTITY_NAME} filters={filters} type="application/vnd.ms-excel"
                                         extension="xls">
                    {getLabel(context.locale, 'evaluations.export')}
                </DropdownDownloadContent>
                <DropdownDownloadContent from={ENTITY_NAME + '/evaluations'} filters={filters}
                                         type="application/vnd.ms-excel"
                                         extension="xls">
                    {getLabel(context.locale, 'evaluations.exportEvaluations')}
                </DropdownDownloadContent>
            </DropdownDownloadButton>
            <DropdownDownloadButton iconType="printer" tooltip="general.print" handleError={toggleModal}>
                <DropdownDownloadContent from={ENTITY_NAME} filters={filters} type="application/pdf" extension="pdf">
                    {getLabel(context.locale, 'evaluations.print')}
                </DropdownDownloadContent>
                <DropdownDownloadContent from={ENTITY_NAME + '/evaluations'} filters={filters} type="application/pdf"
                                         extension="pdf">
                    {getLabel(context.locale, 'evaluations.printEvaluations')}
                </DropdownDownloadContent>
                <DropdownDownloadContent from={ENTITY_NAME + '/evaluationsAll'} filters={filters} type="application/pdf"
                                         extension="pdf">
                    {getLabel(context.locale, 'evaluations.printEvaluationsAll')}
                </DropdownDownloadContent>
            </DropdownDownloadButton>
        </div>
    );
};

const CrudList = (props, context) => {
    const advancedFilters = props.location.state;
    const filters = defaultFilters();
    if (advancedFilters) {
        Object.keys(advancedFilters).map(k => ({
            name: k,
            defaultValue: advancedFilters[k]
        })).forEach(f => filters.push(f));
    }

    const resetFilters = advancedFilters !== undefined && advancedFilters !== null;

    const table = <CollapsibleRowList
        optionLabelName={['companyName', 'departmentName', 'activityName', 'substanceCode']}
        hideEditButton={true}
        hideViewButton={true}
        rowMarker={rowMarker}
    >

        <Show_If_Mutagen_Cancerous>
            <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                <OutputBoxContent label="substancesManagement.revelationProcessTemperaturePre" style={{flex: 2}}>
                    <LocalizedOutputValue name="revelationProcessTemperaturePre"
                                          prefix="substancesManagement.revelationProcessTemperatureValuesPre"/>
                </OutputBoxContent>
                <OutputBox name="revelationHandlingTimeMinutesPre"
                           label="substancesManagement.revelationHandlingTimeMinutesPre"
                           style={{flex: 3}}/>
                <OutputBox name="revelationFrequencyOfUseDaysPre"
                           label="substancesManagement.revelationFrequencyOfUseDaysPre"
                           style={{flex: 3}}/>
                <WithRole roles={['A', 'B', 'C']}>
                    <OutputBoxContent label="substancesManagement.actions" style={{flex: 1}}>
                        <ActionButtons url={props.match.url}/>
                    </OutputBoxContent>
                </WithRole>
            </Horizontal>
        </Show_If_Mutagen_Cancerous>

        <Show_IfNOT_Mutagen_Cancerous>
            <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                <OutputBoxContent label="substancesManagement.dailyQuantity.displayLabel" style={{flex: 2}}>
                    <Vertical>
                        <Horizontal style={{alignItems: 'center'}}>
                            <SubstanceOutputText value="Max"/>
                            <OutputValue name="maxDailyQuantity.value"
                                         style={{marginLeft: '10px', marginRight: '5px'}}/>
                            <OutputValue name="maxDailyQuantity.unit"/>
                        </Horizontal>
                        <Horizontal>
                            <SubstanceOutputText value="Min"/>
                            <OutputValue name="minDailyQuantity.value"
                                         style={{marginLeft: '10px', marginRight: '5px'}}/>
                            <OutputValue name="minDailyQuantity.unit"/>
                        </Horizontal>
                    </Vertical>
                </OutputBoxContent>
                <OutputBoxContent label="substancesManagement.presentQuantity.displayLabel" style={{flex: 2}}>
                    <Horizontal style={{alignItems: 'center'}}>
                        <SubstanceOutputText value="Max"/>
                        <OutputValue name="maxActualQuantity.value" style={{marginLeft: '10px', marginRight: '5px'}}/>
                        <OutputValue name="maxActualQuantity.unit"/>
                    </Horizontal>
                </OutputBoxContent>
                <OutputBoxContent label="substancesManagement.frequency.displayLabel" style={{flex: 2}}>
                    <LocalizedOutputValue name="contactFrequency" prefix="substancesManagement.contactFrequencyValues"/>
                </OutputBoxContent>
                <OutputBoxContent label="substancesManagement.expositionTime.displayLabel" style={{flex: 2}}>
                    <LocalizedOutputValue name="exposureTime" prefix="substancesManagement.expositionTimeValues"/>
                </OutputBoxContent>
                <ShowBasedOnConfig configKey={SUBSTANCE_INVENTORY_VISIBLE}>
                    <OutputBoxContent label="substancesManagement.stock.displayLabel" style={{flex: 2}}>
                        <OutputValue name="stock"/>
                    </OutputBoxContent>
                </ShowBasedOnConfig>
                <ShowBasedOnConfig configKey={SUBSTANCE_INVENTORY_VISIBLE}>
                    <OutputBoxContent label="substancesManagement.dailyUsage.displayLabel" style={{flex: 2}}>
                        <OutputValue name="dailyUsage"/>
                    </OutputBoxContent>
                </ShowBasedOnConfig>
                <WithRole roles={['A', 'B', 'C']}>
                    <OutputBoxContent label="substancesManagement.actions" style={{flex: 1}}>
                        <ActionButtons url={props.match.url}/>
                    </OutputBoxContent>
                </WithRole>
            </Horizontal>
        </Show_IfNOT_Mutagen_Cancerous>


        <Horizontal style={{
            alignItems: 'center',
            backgroundColor: 'rgb(238, 242, 246)',
            borderLeft: '1px solid #7F8FA4',
            borderRight: '1px solid #7F8FA4',
            borderBottom: '1px solid #7F8FA4',
        }}>
            <Horizontal style={{
                fontSize: '0.9em',
                fontWeight: 700,
                color: '#7F8FA4',
                padding: '10px 5px',
            }}>
                <LastEvaluationText style={{marginRight: 10}}/>
                <OutputValue name="lastEvaluation.timestamp" formatter={dateTimeFormatter} defaultValue="---"/>
                <OutputValue name="lastEvaluationIndex" className="last-evaluation-index" hideIf={0}/>
            </Horizontal>
            <PrintEvaluationButton/>
            <ViewEvaluationButton/>
            <WithRole roles={['A', 'B']}>
                <NewEvaluationButton/>
            </WithRole>
            <ArchiveEvaluationButton/>
        </Horizontal>

        <Show_If_Mutagen_Cancerous>
            <Vertical rendered="lastEvaluation">
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxContent label="evaluations.revelationCollectiveProtectionFactor" style={{flex: 3}}>
                        <LocalizedOutputValue name="lastEvaluation.revelationCollectiveProtectionFactor"
                                              prefix="evaluations.revelationCollectiveProtectionFactorValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.revelationProcessTemperature" style={{flex: 3}}>
                        <LocalizedOutputValue name="lastEvaluation.revelationProcessTemperature"
                                              prefix="evaluations.revelationProcessTemperatureValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.revelationChemicalPhysicalState" style={{flex: 3}}>
                        <LocalizedOutputValue name="lastEvaluation.revelationChemicalPhysicalState"
                                              prefix="evaluations.revelationChemicalPhysicalStateValues"/>
                    </OutputBoxContent>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxContent label="evaluations.revelationAmountUsed" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.revelationAmountUsed"
                                              prefix="evaluations.revelationAmountUsedValues"/>
                    </OutputBoxContent>
                    <OutputBox name="lastEvaluation.revelationHandlingTimeMinutes"
                               label="evaluations.revelationHandlingTimeMinutes" formatter={decimalFormatter(2)}
                               style={{flex: 3}}/>
                    <OutputBox name="lastEvaluation.revelationFrequencyOfUseDays"
                               label="evaluations.revelationFrequencyOfUseDays"
                               formatter={decimalFormatter(2)} style={{flex: 3}}/>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBox name="lastEvaluation.bigP" label="evaluations.bigP" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.bigT" label="evaluations.bigT" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.bigS" label="evaluations.bigS" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.bigQ" label="evaluations.bigQ" style={{flex: 2}}/>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBox name="lastEvaluation.bigE" label="evaluations.bigE" style={{flex: 3}}/>
                    <OutputBox name="lastEvaluation.bigF" label="evaluations.bigF" style={{flex: 3}}/>
                    <OutputBox name="lastEvaluation.lcanc"
                               label="evaluations.lcanc.name"
                               formatter={decimalFormatter(2)}
                               style={{flex: 3}}
                    />
                    <ShowBasedOnConfig configKey={EVALUATION_DESCRIPTION_VISIBLE}>
                        <OutputBoxContent label="evaluations.lcanc.description" style={{flex: 3}}>
                            <LocalizedOutputValue name="lastEvaluation.lcancType"
                                                  prefix="evaluations.lcancType"/>
                        </OutputBoxContent>
                    </ShowBasedOnConfig>
                </Horizontal>
            </Vertical>
        </Show_If_Mutagen_Cancerous>

        <Show_IfNOT_Mutagen_Cancerous>
            <Vertical rendered="lastEvaluation">
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxContent label="evaluations.inhalationDistance" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationDistance"
                                              prefix="evaluations.inhalationDistanceValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.inhalationQuantity" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationQuantity"
                                              prefix="evaluations.inhalationQuantityValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.inhalationProperty" style={{flex: 2}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationProperty"
                                              prefix="evaluations.inhalationPropertyValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.inhalationSystemType" style={{flex: 2}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationSystemType"
                                              prefix="evaluations.inhalationSystemTypeValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.inhalationControlType" style={{flex: 2}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationControlType"
                                              prefix="evaluations.inhalationControlTypeValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.inhalationExposureTime" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.inhalationExposureTime"
                                              prefix="substancesManagement.expositionTimeValues"/>
                    </OutputBoxContent>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBox name="lastEvaluation.smallD" label="evaluations.smallD" style={{flex: 1}}/>
                    <OutputBox name="lastEvaluation.bigD" label="evaluations.bigD" style={{flex: 3}}/>
                    <OutputBox name="lastEvaluation.bigU" label="evaluations.u" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.bigC" label="evaluations.c" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.bigI" label="evaluations.i" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.eInal" label="evaluations.einal" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.rInal" label="evaluations.rinal" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.rInalH" label="evaluations.rinalH" style={{flex: 2}}/>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBoxContent label="evaluations.skinSystemType" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.skinSystemType"
                                              prefix="evaluations.skinSystemTypeValues"/>
                    </OutputBoxContent>
                    <OutputBoxContent label="evaluations.skinContactLevel" style={{flex: 1}}>
                        <LocalizedOutputValue name="lastEvaluation.skinContactLevel"
                                              prefix="evaluations.skinContactLevelValues"/>
                    </OutputBoxContent>
                    <OutputBox name="lastEvaluation.ecute" label="evaluations.ecute" style={{flex: 2}}/>
                    <OutputBox name="lastEvaluation.rcute" label="evaluations.rcute" style={{flex: 1}}/>
                    <OutputBox name="lastEvaluation.rcuteH" label="evaluations.rcuteH" style={{flex: 1}}/>
                </Horizontal>
                <Horizontal style={{backgroundColor: 'rgb(248, 252, 253)'}}>
                    <OutputBox name="lastEvaluation.scoreP" label="evaluations.scoreP" style={{flex: 1}}/>
                    <OutputBox name="lastEvaluation.scoreH" label="evaluations.scoreH" style={{flex: 1}}/>
                    <OutputBox name="lastEvaluation.rcum"
                               label="evaluations.rcum.name"
                               formatter={decimalFormatter(2)}
                               style={{flex: 1}}
                    />
                    <OutputBox name="lastEvaluation.rcumH"
                               label="evaluations.rcumH.name"
                               formatter={decimalFormatter(2)}
                               style={{flex: 1}}
                    />
                    <ShowBasedOnConfig configKey={EVALUATION_DESCRIPTION_VISIBLE}>
                        <OutputBoxContent label="evaluations.rcumH.description" style={{flex: 1}}>
                            <LocalizedOutputValue name="lastEvaluation.rcumHType"
                                                  prefix="evaluations.cumulativeRiskType"/>
                        </OutputBoxContent>
                    </ShowBasedOnConfig>
                </Horizontal>
            </Vertical>
        </Show_IfNOT_Mutagen_Cancerous>
    </CollapsibleRowList>;

    return <List title={TITLE}
                 entityName={ENTITY_NAME}
                 entityRoute={ENTITY_ROUTE}
                 component={table}
                 hideAddButton={true}
                 filters={filters}
                 hasAdditionalFilters={resetFilters}
                 showSearchButton={true}
                 crudClassName="substancesManagement"
                 additionalButtons={exportButtons}
    />;
};

const SubstancesManagement = props => {
    const basePath = props.match.url;
    return (
        <MainContainer>
            <Switch>
                <Route exact path={basePath} component={CrudList}/>
                <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />}/>
                <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />}/>
                <Route exact path={basePath + '/search'} component={AdvancedSearch}/>
                <Route path={basePath + '/:number/evaluation'} component={Evaluations}/>
            </Switch>
        </MainContainer>
    );
};


export default SubstancesManagement;



// WEBPACK FOOTER //
// ./src/main/pages/SubstancesManagement.js